import React, { useState } from 'react'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import { ReactSVG } from 'react-svg'
import DictionaryTable from '../DIctionaryTable'

import styles from './preview.module.scss'
import { useEffect } from 'react'

interface props {
  preview: string
  title?: string
  details?: string | {}
  actions?: React.ReactNode[]
  onClickFn?: () => void
  previewSize?: [number, number]
  iconCardWidth?: number
  previewSvgColor?: 'dark' | 'light' | 'inherit'
  componentType?: 'thumbnail' | 'icon'
  active?: boolean
}

export default function PreviewComponent({
  preview,
  title,
  details,
  actions,
  onClickFn,
  previewSize = [300, 300],
  previewSvgColor = 'inherit',
  componentType = 'thumbnail',
  iconCardWidth,
  active = false,
}: props) {
  const [elv, setElv] = useState(active ? 10 : 0)

  const isSvg = (path: string): boolean => {
    const pathArray = path.split('.')
    const ext = pathArray[pathArray.length - 1]

    if (ext === 'svg') {
      return true
    }
    return false
  }
  useEffect(() => {
    setElv(active ? 10 : 0)
  }, [active])

  return (
    <Card
      style={{
        margin: '1rem',
        display: 'inline-block',
        backgroundColor: active ? '#fff1' : 'transparent',
        backgroundImage: 'none',
        minWidth: previewSize[0],
      }}
      elevation={elv}
      onMouseEnter={() => setElv(10)}
      onMouseLeave={() => setElv(active ? 10 : 0)}
    >
      {componentType === 'icon' ? (
        <div>
          <div>
            <CardActionArea
              style={{
                display: 'flex',
                alignItems: 'center',
                width: iconCardWidth,
                padding: '1rem',
              }}
              onClick={onClickFn}
            >
              {preview.length > 7 && preview[0] !== '#' ? (
                isSvg(preview) ? (
                  <ReactSVG
                    className={styles[`svgContainer__${previewSvgColor}`]}
                    src={preview}
                    beforeInjection={svg => {
                      svg.setAttribute(
                        'style',
                        `width: ${previewSize[0]}px;
                          height: ${previewSize[0]}px;`
                      )
                      svg.setAttribute('width', `${previewSize[0]}`)
                      svg.setAttribute('height', `${previewSize[1]}`)
                    }}
                  />
                ) : (
                  <CardMedia
                    style={{ width: previewSize[0], height: previewSize[1] }}
                    image={preview}
                    title="Contemplative Reptile"
                  />
                )
              ) : (
                <div
                  style={{
                    width: previewSize[0],
                    height: previewSize[1],
                    backgroundColor: preview,
                  }}
                />
              )}
              <CardContent style={{ flex: '1 0 auto' }}>
                <Typography component="h5" variant="h5">
                  {title}
                </Typography>
                {typeof details === 'string' && (
                  <Typography
                    variant="subtitle1"
                    color="textSecondary"
                    style={{
                      maxWidth: '400px',
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    {details}
                  </Typography>
                )}
                {typeof details === 'object' && (
                  <DictionaryTable dict={details} />
                )}
              </CardContent>{' '}
            </CardActionArea>
          </div>
        </div>
      ) : (
        <>
          {' '}
          <CardActionArea
            onClick={onClickFn}
            style={{
              zIndex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '1rem',
            }}
          >
            {isSvg(preview) ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ReactSVG
                  className={styles[`svgContainer__${previewSvgColor}`]}
                  src={preview}
                  beforeInjection={svg => {
                    svg.setAttribute(
                      'style',
                      `width: ${previewSize[0]}px;
                       height: ${previewSize[0]}px;`
                    )
                    svg.setAttribute('width', `${previewSize[0]}`)
                    svg.setAttribute('height', `${previewSize[1]}`)
                  }}
                />
              </div>
            ) : (
              <CardMedia
                style={{ width: previewSize[0], height: previewSize[1] }}
                image={preview}
                title="Contemplative Reptile"
              />
            )}
            <CardContent style={{ textAlign: 'center' }}>
              <Typography gutterBottom variant="h5" component="h2">
                {title}
              </Typography>
              {typeof details === 'string' && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="p"
                  style={{
                    maxWidth: Math.abs(previewSize[0]),
                    maxHeight: '300px',
                    display: 'flex',
                    flexWrap: 'wrap',
                  }}
                >
                  {details.slice(0, 40)}...
                </Typography>
              )}
            </CardContent>
          </CardActionArea>
        </>
      )}{' '}
      {actions && (
        <CardActions
          style={{
            opacity: elv,
            borderTop: '1px solid #fff2',
          }}
        >
          {actions}
        </CardActions>
      )}
    </Card>
  )
}
